// extracted by mini-css-extract-plugin
export var banner = "_ps-0";
export var settingRow = "_ps-2";
export var titleIcon = "_ps-1";